import _ from "i18n";

import { S3_FOLDER_URL_PROD } from "../config";
import { TEMPLATE_TYPES } from "../constants";

export const DEFAULT_BOOK_COVER = `${S3_FOLDER_URL_PROD}/emailing/img/no-book-cover.png`;

const SUPPORTED_LABEL_LANGUAGES = ["fr", "nl", "en"];

const normalizeLanguage = (language) => {
  const lng = (language || "").toLowerCase();
  return SUPPORTED_LABEL_LANGUAGES.includes(lng) ? lng : "fr";
};

const firstFilled = (source, keys) => {
  for (const key of keys) {
    const value = source?.[key];
    if (typeof value === "string" && value.trim() !== "") return value.trim();
    if (typeof value === "number") return String(value);
  }
  return "";
};

export const getBookTitle = (book) => firstFilled(book, ["title", "name"]);

export const getBookCover = (book) =>
  firstFilled(book, [
    "cover",
    "coverUrl",
    "coverImage",
    "image",
    "imageUrl",
    "picture",
    "pictureUrl",
    "thumbnail",
  ]) || DEFAULT_BOOK_COVER;

export const getBookUrl = (book) =>
  firstFilled(book, ["selling_url", "sellingUrl", "url"]);

export const getBookAuthors = (book) =>
  (Array.isArray(book?.authors) ? book.authors : [])
    .map((author) =>
      typeof author === "string"
        ? author
        : `${author?.firstName || ""} ${author?.lastName || ""}`.trim(),
    )
    .filter((name) => name !== "")
    .join(", ");

export const formatBook = (book, language) => {
  const price = firstFilled(book, ["price", "amount"]);

  return {
    id: book?.id,
    type: TEMPLATE_TYPES["BOOK_LAYOUT"],
    bookTitle: getBookTitle(book),
    bookCover: getBookCover(book),
    bookAuthors: getBookAuthors(book),
    bookUrl: getBookUrl(book),
    consultBookLabel: _("Consult the book", normalizeLanguage(language)),
  };
};
